/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Promo = {
    /**
     * Promo ID
     */
    id?: string;
    /**
     * Promo type
     */
    type?: string;
    /**
     * Promo code
     */
    code?: string;
    /**
     * Business reason for creating the promo
     */
    reason?: string;
    /**
     * Usage count limit
     */
    count?: number;
    /**
     * Promo value in cents
     */
    value?: number;
    /**
     * Promo status (0=Active, 1=Disabled)
     */
    status?: Promo.status;
    createdAt?: string;
    updatedAt?: string;
};
export namespace Promo {
    /**
     * Promo status (0=Active, 1=Disabled)
     */
    export enum status {
        '_0' = 0,
        '_1' = 1,
    }
}

